module.exports = __webpack_public_path__ + "img/point.affd1e48.svg";